export const BUSINESS_PROFILE_STORAGE_KEY = 'business:onboarding';

// @repo/common BusinessSteps의 칩 value와 같아야 저장된 선택값이 그대로 표시된다
export const BUSINESS_TYPES = [
  'Startup',
  'Agency',
  'Enterprise',
  'Education',
  'Public or non-profit',
  'HR agency',
  'Other',
];

export const BUSINESS_PURPOSES = [
  'Hire talent',
  'Find partners',
  'Use business services',
  'Contact Koready team',
  'Other',
];

export const BUSINESS_ROLES = [
  'Already in Korea',
  'International students (D-2, D-4)',
  'Job seekers (D-10)',
  'Residents with open work rights (F-2, F-5, F-6)',
  'Overseas Koreans (F-4)',
  'Professional visa holders',
  'Professionals (E-7)',
  'Skilled workers (E-7-4)',
  'Professors & researchers (E-1, E-3)',
  'Language instructors (E-2)',
  'Global talent outside Korea',
  'Other',
];
